import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { getMembersList } from '../../../../api/report/report';
import { DashboardMemberDetails, MemberSummaryData } from '../../../../api/report/types';
import { AppDispatch, RootState } from '../../../../app/store';
import { stateNeedsUpdating } from '../../../../reduxHelpers/stateHelpers';
import { MemberDataSlice, MemberId } from '../slice';

export const asyncLoadMembersSummaryData = createAsyncThunk<
    MemberSummaryData,
    { force?: boolean } | undefined,
    {
        dispatch: AppDispatch;
        state: RootState;
    }
>(
    'member/loadDashboardData',
    async () => {
        return await getMembersList();
    },
    {
        condition: (args, { getState }) => {
            const { members } = getState();

            return !!args?.force || stateNeedsUpdating(members?.memberDashboardSummaries);
        },
    }
);

const reducer = (builder: ActionReducerMapBuilder<MemberDataSlice>) => {
    builder.addCase(asyncLoadMembersSummaryData.pending, (state) => {
        state.memberDashboardSummaries.status = state.memberDashboardSummaries.loadedTimestamp
            ? 'reloading'
            : 'pending';
    });

    builder.addCase(asyncLoadMembersSummaryData.rejected, (state) => {
        state.memberDashboardSummaries.status = 'error';
    });

    builder.addCase(asyncLoadMembersSummaryData.fulfilled, (state, action) => {
        state.memberDashboardSummaries.status = 'success';
        state.memberDashboardSummaries.loadedTimestamp = Date.now();
        state.memberDashboardSummaries.data = action.payload.members.reduce((previousValue, current) => {
            previousValue[current.member.userId] = current;

            return previousValue;
        }, {} as Record<MemberId, DashboardMemberDetails>);
    });
};

export default reducer;
